import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function ConfirmButton({ otpValue, navigateTo }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const valid = true;
  const handleConfirmClick = () => {
    console.log("OTP Confirmed:", otpValue);
    if (valid) {
      setTimeout(() => {
        navigate(navigateTo); // Replace '/next-page' with your desired path
      }, 1000);
    }
  };
  return <PrimaryButton text={t("confirm")} onClick={handleConfirmClick} />;
}
